import { useEffect, useState } from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  type CarouselApi,
} from '@/components/ui/carousel';
import { cn } from '@/lib/utils';

const SLIDES = [
  {
    label: 'Primary Residence',
    content: (
      <>
        <p>
          When buying your Primary Residence - whether it is your first home, a step-up home, or the
          home you plan on retiring in - it is so important to work with a team that takes the time
          to listen and understand your needs.
        </p>
        <p className="mt-4">
          Buying a home is a ton of fun, and one of the biggest senses of accomplishment you will
          experience in life. It will provide shelter, laughter, joy, and a safe place for many
          memories to be made. It is also one of the largest financial decisions a person makes, and
          if done right can be a wise investment. We take pride in looking at the big picture and
          ensuring you find the perfect home to enrich all aspects of your life.
        </p>
      </>
    ),
  },
  {
    label: 'Investment Property',
    content: (
      <p>
        Real estate investing in your backyard may or may not be a good idea depending on where you
        live. With the help of technology and the internet we make it simple to invest where you
        want <em>and</em> live where you want. We provide the data necessary for you to make
        educated decisions to determine if real estate in your backyard is a good investment for
        what you are looking to accomplish. Whether your objective is cash flow, appreciation, or
        capital preservation we can help you grow your wealth passively or actively, conservatively
        or aggressively. We take tremendous pride in the results of our work and are constantly
        innovating to remain the best at what we do.
      </p>
    ),
  },
  {
    label: 'Vacation Home',
    content: (
      <p>
        Vacations are a blast, and vacation homes are a home away from home! If you are looking to
        purchase a vacation home, know that it is either a toy or a part time job. Vacation rentals
        are the farthest thing from a passive investment. Buy and hold real estate investing is best
        with long term tenants and easiest when it is as hands off as possible. Vacation homes are
        the same as boats, sports cars, and RVs. They are a ton of fun and give you the ability to
        create life-long memories, build family traditions, and leave a legacy that can be passed
        down to your kids and grandchildren. Whether your home away from home is a beach cottage,
        cabin tucked away in the mountains, or a highrise over-looking the city skyline, we would
        love to make your dream come true.
      </p>
    ),
  },
];

const BuyingSlideshow = () => {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!api) return;
    setCurrent(api.selectedScrollSnap());
    api.on('select', () => setCurrent(api.selectedScrollSnap()));
  }, [api]);

  return (
    <div
      className="overflow-hidden rounded-lg"
      style={{
        backgroundImage: "url('/static/images/for-buy.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
      }}
    >
      <div className="bg-white/80">
        {/* Tab buttons */}
        <div className="flex">
          {SLIDES.map((slide, i) => (
            <button
              key={slide.label}
              onClick={() => api?.scrollTo(i)}
              className={cn(
                'flex-1 px-6 py-5 text-center font-raleway font-bold transition-colors',
                current === i ? 'bg-[#2d3f5e] text-white' : 'text-[#2d3f5e] hover:bg-white/50',
              )}
            >
              {slide.label}
            </button>
          ))}
        </div>

        {/* Carousel */}
        <Carousel setApi={setApi} opts={{ loop: true }}>
          <CarouselContent>
            {SLIDES.map((slide) => (
              <CarouselItem key={slide.label}>
                <div className="px-16 py-10 text-sm leading-relaxed text-gray-700 md:text-base">
                  {slide.content}
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="left-2" />
          <CarouselNext className="right-2" />
        </Carousel>
      </div>
    </div>
  );
};

export { BuyingSlideshow };
